var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStarHomescreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 58 58",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.512 55.361C12.307 55.361 12.102 55.298 11.929 55.172C11.624 54.95 11.471 54.574 11.535 54.204L14.597 36.356L1.631 23.72C1.361 23.456 1.264 23.063 1.38 22.705C1.497 22.347 1.807 22.085 2.181 22.031L20.098 19.427L28.113 3.19C28.279 2.851 28.624 2.637 29 2.637L29 2.637C29.377 2.637 29.722 2.851 29.887 3.19L37.9 19.427L55.819 22.031C56.192 22.086 56.502 22.346 56.619 22.705C56.735 23.063 56.64 23.457 56.369 23.72L43.402 36.36L46.463 54.206C46.526 54.576 46.374 54.952 46.07 55.174C45.765 55.398 45.36 55.427 45.026 55.25L29 46.823L12.972 55.249C12.827 55.323 12.669 55.361 12.512 55.361Z",
    fill: "#ffe785",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#000000",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarHomescreen);
export default __webpack_public_path__ + "static/media/icon_star_homescreen.23ee02cd7e0c0ec5462fee8f290ec68a.svg";
export { ForwardRef as ReactComponent };